import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['editor', 'subject']

  // Fügt {{token}} an der Cursorposition in den Trix-Body-Editor ein.
  insert(event) {
    const trixEditor = this.editorTarget.editor
    if (!trixEditor) return // Trix noch nicht initialisiert

    trixEditor.insertString(`{{${event.params.token}}}`)
    this.editorTarget.focus()
  }

  // Fügt {{token}} an der Cursorposition in das einfache Betreff-Textfeld ein.
  insertSubject(event) {
    const input = this.subjectTarget
    const token = `{{${event.params.token}}}`
    const start = input.selectionStart != null ? input.selectionStart : input.value.length
    const end = input.selectionEnd != null ? input.selectionEnd : input.value.length

    input.value = input.value.slice(0, start) + token + input.value.slice(end)
    const caret = start + token.length
    input.setSelectionRange(caret, caret)
    input.focus()
  }
}
